<template>
  <div class="form__thanks row">
    <div
      v-if="!form.draft && form.status == 'not_reviewed'"
      class="col-md-6 offset-md-3"
    >
      <p>
        Dziękujemy za Państwa zgłoszenie.<br />
        Wydarzenie zostało przekazane do weryfikacji.
      </p>
      <Btn variant="outline-primary" @click="$router.push('/certification')">
        Lista wydarzeń
      </Btn>
    </div>

    <div
      v-if="!form.draft && form.status == 'not_reviewed_late'"
      class="col-md-6 offset-md-3"
    >
      <p>
        Dziękujemy za Państwa zgłoszenie.<br />
        Wydarzenie zostało przekazane do weryfikacji.
      </p>
      <p>
        <strong
          >UWAGA: wydarzenie może nie zostać ocenione w związku ze zbyt późnym
          zgłoszeniem.</strong
        >
      </p>
      <Btn variant="outline-primary" @click="$router.push('/certification')">
        Lista wydarzeń
      </Btn>
    </div>

    <div
      v-if="form.draft || form.status === 'draft'"
      class="col-md-6 offset-md-3"
    >
      <p>
        Kopia robocza zgłoszenia została zapisana pomyślnie.
      </p>
      <p>
        <strong>
          UWAGA: Musisz wysłać zgłoszenie, aby wydarzenie zostało ocenione.
        </strong>
      </p>
      <Btn variant="outline-primary" @click="$router.push('/certification')">
        Lista wydarzeń
      </Btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseCertificationThanks",
  props: {
    form: {
      type: Object,
      required: true
    }
  }
};
</script>
